import constants from '@Constants'
import { datadogRum } from '@datadog/browser-rum'
const { IS_PROD, TRACK } = constants

const initDatadog = () => {
  if (!IS_PROD) {
    return
  }

  datadogRum.init({
    applicationId: TRACK.DATADOG.APPLICATION_ID,
    clientToken: TRACK.DATADOG.CLIENT_TOKEN,
    site: 'us5.datadoghq.com',
    env: 'production',
    service: 'front-web-core-docs-qsa',
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    defaultPrivacyLevel: 'mask-user-input',
    allowedTracingUrls: ['https://api.cora.com.br'],
  })
}

export default initDatadog
